"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
interface FaqItem {
  id: string;
  question: string;
  answer: React.ReactNode;
}
const faqItems: FaqItem[] = [{
  id: "item-1",
  question: "Hur snabbt får jag svar och offert på min badrumsrenovering?",
  answer: "Vi går igenom din förfrågan och återkommer personligen inom 24 timmar. Därefter stämmer vi av projektet och bokar vid behov in ett hembesök. Normalt har du ett komplett och specificerat kostnadsförslag i handen inom ett par arbetsdagar efter vårt möte."
}, {
  id: "item-2",
  question: "Kostar det något att begära en offert eller boka hembesök?",
  answer: "Nej, både offertförfrågan och vårt rådgivande hembesök är helt kostnadsfria och utan förpliktelser. Du binder dig inte till någonting förrän vi har gått igenom kalkylen tillsammans och du godkänt avtalet."
}, {
  id: "item-3",
  question: "Vad kostar det att renovera ett badrum och ingår fast pris?",
  answer: "Priset påverkas av badrummets yta, underarbete, rördragning och dina materialval. Vi lämnar alltid en specificerad kalkyl med fast pris på entreprenaden så att du slipper oväntade kostnader. Dessutom drar vi av ROT-avdraget på 30 % av arbetskostnaden direkt på fakturan."
}, {
  id: "item-4",
  question: "Vad behöver jag förbereda innan jag skickar offertförfrågan?",
  answer: "Du behöver inga tekniska ritningar. Det räcker att ange ungefärlig yta och beskriva dina grundläggande önskemål i formulärets meddelandefält. Söker du idéer kring kakel, färger eller layout kan du utforska vårt galleri för badrumsinspiration."
}, {
  id: "item-5",
  question: "Kan jag begära offert på badrumsrenovering i Karlstad eller Arvika?",
  answer: "Ja, vi erbjuder totalentreprenad i hela Värmland. Oavsett om du planerar en badrumsrenovering i Karlstad med omnejd eller söker hantverkare för badrumsrenovering i Arvika kan du skicka din förfrågan direkt via formuläret ovan."
}];
export default function Quotefaq() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="quotefaq" data-nav="light" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground tracking-tight">
            Vanliga frågor om offert på badrumsrenovering
          </h2>
          <p className="font-default text-lg text-muted-foreground md:text-xl mt-4 leading-relaxed max-w-3xl mx-auto">
            Här hittar du svar på vanliga frågor om offert, kostnad och vilket underlag vi behöver för att kunna bedöma din badrumsrenovering.
          </p>
        </div>

        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="bg-card text-card-foreground border border-border rounded-xl shadow-sm p-6 md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index} className="border-b border-border last:border-b-0 py-2">
                <AccordionTrigger type="button" className="text-left hover:no-underline hover:text-primary transition-colors py-4">
                  <span className="block font-default text-base md:text-lg font-semibold text-foreground">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pt-1 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </motion.div>
      </div>
    </section>;
}